import { SystemState } from './types'

export const getUser = (state: SystemState) => state.user
